module.exports = __webpack_public_path__ + "img/DE02525.9e9d97f6.png";